export default class Cards {
  constructor(element) {
    this.element = element;

    this.options = {
      rootMargin: '-50% 0px -50% 0px',
      repeat: true,
    };

    this.init();
  }
  init() {
    if (window.innerWidth >= 1300) return;

    this.setOptions();

    this.observer = new IntersectionObserver(
      this.watch.bind(this),
      this.options
    );

    const items = this.element.querySelectorAll('[data-card]');
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      this.observer.observe(item);
    }
  }
  setOptions() {
    if ('noRepeat' in this.element.dataset) {
      this.options.repeat = false;
    }
  }

  watch(entries, observer) {
    //console.log('méthode watch');
    for (let i = 0; i < entries.length; i++) {
      const entry = entries[i];
      const target = entry.target;
      if (entry.isIntersecting) {
        //console.log('oui');
        target.classList.add('is-active');
        if (!this.options.repeat) {
          observer.unobserve(target);
        }
      } else {
        //console.log('non');
        target.classList.remove('is-active');
      }
    }
  }
}
